"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaskDropdownMulti = TaskDropdownMulti;
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireWildcard(require("react"));
var _Form = _interopRequireDefault(require("react-bootstrap/Form"));
var _ModalFeedback = _interopRequireDefault(require("../ModalFeedback/ModalFeedback"));
var _CompletedContext = require("../CompletedContext");
var _DesignComponents = require("../DesignComponents/DesignComponents");
require("./TaskSelect.scss");
var DEBUG = false;
function TaskDropdownMulti(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "task task-dropdown-multi"
  }, children);
}
var TaskSelect = exports.default = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TaskSelect, _Component);
  var _super = (0, _createSuper2.default)(TaskSelect);
  function TaskSelect(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TaskSelect);
    _this = _super.call(this, props);
    _this.returnDropDownOptions = function () {
      var options = [];
      _this.props.options.forEach(function (value, index) {
        DEBUG && console.log("option value", index);
        options.push( /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown.Option, {
          key: value + index,
          selected: "".concat(_this.props.state.selected) === "".concat(index),
          value: "".concat(index),
          label: _this.props.optionStyling ? value : (0, _DesignComponents.toText)(value)
        }, value));
      });
      return options;
    };
    _this.state = props.state || {};
    if (!_this.state.initialized) {
      _this.state.initialized = true;
      // Initial state is set here, since the constructor can be called more than once.
      _this.state.completed = false;
      _this.state.selected = undefined;
      _this.state.unanswered = true;
    }
    return _this;
  }
  (0, _createClass2.default)(TaskSelect, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }
      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
      var completed = this.state.selected === this.props.correct;
      if (this.state.completed !== completed) {
        this.setState({
          completed: completed
        });
      }
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      if (this.props.label === undefined && !this.props.suppressErrors) {
        throw new Error("TaskSelect: Prop 'label' is required in order to be accessible.");
      }
      var dropdownStatus = /*#__PURE__*/_react.default.createElement("span", {
        className: "sr-only"
      }, this.state.completed ? " Correct and completed." : this.state.unanswered ? " Incomplete" : " Incorrect and incomplete.");
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "task task-select" + (this.state.completed ? " completed" : ""),
        style: (0, _objectSpread2.default)({
          display: this.props.inline ? "inline-block" : undefined,
          marginLeft: "1ch",
          marginRight: "1ch"
        }, this.props.style)
      }, /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown, {
        className: "mb-1",
        matchWidth: this.props.matchWidth,
        buttonWidth: this.props.buttonWidth,
        disabled: this.state.completed,
        isValid: this.state.selected !== undefined ? this.state.completed : null,
        label: /*#__PURE__*/_react.default.createElement("span", {
          className: this.props.srOnly ? "sr-only" : ""
        }, this.props.label, dropdownStatus),
        inline: this.props.inline,
        description: /*#__PURE__*/_react.default.createElement("span", {
          className: this.props.srOnly ? "sr-only" : ""
        }, this.props.description),
        value: this.state.selected,
        buttonContents: this.props.options[this.state.selected],
        buttonClass: this.state.completed ? "nds-button--outline nds-button nds-dropdown__button form-control is-valid" : undefined,
        onChange: function onChange(e) {
          var index = Number(e.value);
          var showFeedback = index !== _this3.props.correct || _this3.props.feedback && _this3.props.feedback[index];
          window.setTimeout(function () {
            _this3.setState({
              selected: index,
              showFeedback: showFeedback,
              unanswered: false
            });
          }, 0);
        }
      }, this.returnDropDownOptions()), /*#__PURE__*/_react.default.createElement(_ModalFeedback.default, {
        correct: this.state.completed,
        show: this.state.showFeedback && !this.props.noModal,
        onHide: function onHide() {
          if (_this3.state.completed) {
            _this3.setState({
              showFeedback: false
            });
          } else {
            _this3.setState({
              selected: undefined,
              showFeedback: false
            });
          }
        },
        children: this.props.feedback && this.props.feedback[this.state.selected]
      }));
    }
  }]);
  return TaskSelect;
}(_react.Component);
TaskSelect.contextType = _CompletedContext.CompletedContext;